import { render, staticRenderFns } from "./ChangeVatin.vue?vue&type=template&id=0a423d3c&"
import script from "./ChangeVatin.vue?vue&type=script&lang=js&"
export * from "./ChangeVatin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports